/**
 * @author      warinya.rojanasuwan@zumper.com (Warinya Rojanasuwan)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { traverseParentsForSelectors } from './traverseParentsForSelectors'

export const getCLSDebugTarget = (entries: any[] = []) => {
  if (!entries.length) {
    return
  }
  const largestShift = entries.reduce((a, b) => {
    return a && a.value > b.value ? a : b
  })
  if (largestShift?.sources?.length) {
    const largestSource = largestShift.sources.reduce((a: any, b: any) => {
      return a.node &&
        a.previousRect.width * a.previousRect.height >
          b.previousRect.width * b.previousRect.height
        ? a
        : b
    })
    if (largestSource?.node) {
      const selectorString = traverseParentsForSelectors(
        largestSource.node as HTMLElement,
        ''
      )
      return selectorString
    }
  }
}
